import CurrencySwitch from "./CurrencySwitch";
import { formatCurrency } from "@/betby/utils/currency";
import gcCoin from "@/betby/assets/image/gc-coin.png";
import scCoin from "@/betby/assets/image/sc-coin.png";
import gcAdd from "@/betby/assets/image/gc-add.webp";
import scAdd from "@/betby/assets/image/sc-add.webp";
import slotIcon from "@/betby/assets/image/slot.png";
import { cn } from "@/betby/lib/utils";
import { useHeaderViewModel } from "@/betby/viewmodels/useHeaderViewModel";
import { useNavigate } from "react-router-dom";

interface HeaderProps {
  onBack?: () => void;
  onAddClick?: () => void;
}

export default function Header({ onBack, onAddClick }: HeaderProps) {
  const navigate = useNavigate();
  const { currentMode, currentBalance, handleBackClick } = useHeaderViewModel({
    onBack,
  });
  const currencyLabel = currentMode.toUpperCase();

  // 根据货币类型定义样式
  const currencyStyles = {
    gc: {
      textColor: "#EEAB19", // 金色
      icon: gcCoin,
      addIcon: gcAdd,
      mainColor: "#EEAB19",
    },
    sc: {
      textColor: "#12D06C", // 绿色
      icon: scCoin,
      addIcon: scAdd,
      mainColor: "#12D06C",
    },
  };

  const style = currencyStyles[currentMode];

  return (
    <nav className="fixed top-0 left-0 right-0 flex items-center justify-between px-3 bg-[#321F48] h-[50px] z-999 flex gap-3">
      {/* 左侧返回按钮 (Slot样式) */}
      <button
        onClick={() => navigate("/")}
        className={cn(
          "flex items-center gap-1 h-[34px] px-3 rounded-full transition-all duration-200 hover:opacity-90 active:scale-95 ",
        )}
        style={{ background: "rgb(9, 137, 255" }}
      >
        <span
          className="text-[#140C1C] font-black text-base font-['Rubik'] leading-none"
          style={{ padding: "0 8px" }}
        >
          Back
        </span>
      </button>

      {/* 货币显示区域 */}
      <div className="max-w-[250px] flex-1 flex justify-between p-1 pl-3 bg-black/25 rounded-full items-center gap-2 relative h-[34px]">
        {/* 货币信息内容 */}
        <div className="relative flex items-center gap-2 z-10 flex-1">
          {/* 货币图标 */}
          <div className="w-5 h-5 shrink-0 flex items-center justify-center">
            <img
              src={style.icon}
              alt={currencyLabel}
              width={20}
              height={20}
              className="object-contain"
            />
          </div>

          {/* 货币余额文本 */}
          <span
            className="font-bold text-base whitespace-nowrap"
            style={{ color: style.textColor }}
          >
            {currencyLabel} {formatCurrency(currentBalance, currentMode)}
          </span>
        </div>
        {/* 添加按钮 */}
        {onAddClick && (
          <button
            onClick={() => (window as any)?.setShowStore()}
            className="w-[26px] h-[26px] rounded-full flex items-center justify-center cursor-pointer transition-all duration-200 hover:opacity-80 shrink-0"
          >
            <img
              src={style.addIcon}
              alt="添加"
              width={26}
              height={26}
              className="object-contain"
            />
          </button>
        )}
      </div>

      {/* 货币切换开关 */}
      <div className="flex items-center">
        <CurrencySwitch />
      </div>
    </nav>
  );
}
